import CopyToClipboardButton from '@oneblink/apps-react/dist/components/renderer/CopyToClipboardButton'
export default CopyToClipboardButton
